const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '3px',
    alignItems: 'center'
  },
  badge: {
    padding: '0 3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'green',
    borderRadius: '4px',
    color: 'white'
  },
  clickableBadge: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.9
    }
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    backgroundColor: 'white',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: '900px',
    maxHeight: '90vh',
    overflowY: 'auto',
    padding: '12px',
    borderRadius: '8px',
    outline: 'none',
  },
  tableContainer: {
    marginTop: '10px',
    marginBottom: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    overflow: 'hidden',
    maxHeight: '500px',
    overflowY: 'auto'
  },
  tableHeader: {
    padding: '8px',
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #ddd',
    borderRight: '1px solid #ddd',
    '&:last-child': {
      borderRight: 'none'
    }
  },
  headerText: {
    fontWeight: 'bold'
  },
  tableCell: {
    padding: '8px',
    borderBottom: '1px solid #ddd',
    borderRight: '1px solid #ddd',
    '&:last-child': {
      borderRight: 'none'
    }
  },
  actionsPanel: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '10px'
  }
}

export default styles;
